module.exports = __webpack_public_path__ + "static/media/icon32.0a5e26d1.png";